if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.sourceButton = document.getElementById(this.dataset.sourceButton);
        this.button = this.querySelector('.sticky-add-to-cart__button');
        this.buttonLabel = this.querySelector('.sticky-add-to-cart__button-label');
        this.price = this.querySelector('.sticky-add-to-cart__price');
        this.image = this.querySelector('.sticky-add-to-cart__image');

        if (!this.sourceButton || !this.button) return;

        this.syncButton();
        this.updateVisibility = this.updateVisibility.bind(this);
        this.visibilityObserver = new IntersectionObserver(() => this.updateVisibility());
        this.visibilityObserver.observe(this.sourceButton);
        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        window.addEventListener('resize', this.updateVisibility);
        window.requestAnimationFrame(this.updateVisibility);

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.sourceButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.updateVariant(event));
        }
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.unsubscribeVariant?.();
        if (this.updateVisibility) {
          window.removeEventListener('scroll', this.updateVisibility);
          window.removeEventListener('resize', this.updateVisibility);
        }
      }

      updateVisibility() {
        const hasPassedButton = this.sourceButton.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visible', hasPassedButton);
      }

      syncButton() {
        const disabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        const sourceLabel = this.sourceButton.querySelector('span')?.textContent?.trim();

        this.button.disabled = disabled;
        this.button.toggleAttribute('aria-disabled', disabled);
        if (sourceLabel) this.buttonLabel.textContent = sourceLabel;
      }

      updateVariant(event) {
        const { sectionId, html, variant } = event?.data || {};
        if (`${sectionId}` !== `${this.sectionId}`) return;

        const priceNode = html?.getElementById(`price-${sectionId}`);
        const updatedImage = variant?.featured_media?.preview_image?.src;

        if (priceNode && this.price) {
          const sourcePrice = priceNode.querySelector('.price');
          if (sourcePrice) {
            const clonedPrice = sourcePrice.cloneNode(true);
            clonedPrice.querySelector('.price__shipping-label')?.remove();
            this.price.replaceChildren(clonedPrice);
          }
        }
        if (updatedImage && this.image) {
          this.image.src = updatedImage;
          this.image.removeAttribute('srcset');
        }

        window.requestAnimationFrame(() => this.syncButton());
      }
    }
  );
}
